/* The section home, ported from renderSectionHome (app.ts ~3605). Selecting a
   section lands on the nav bar alone — no record cards (DIR7, per Trevor). The
   content area says honestly that nothing is open and names the two verbs;
   records are browsed from the tree and read on their own panels, where the
   status badge and the per-state actions live.

   Shared: renderProjects and renderPortfolio both delegate here in the vanilla
   source, so ProjectsView renders it with the project noun and PortfolioView
   (another bundle) reuses it with the kind's singular. `loadWhat` is what the
   Loading / LoadError banners name, matching the vanilla calls exactly
   (projects → "projects"; portfolio → "the portfolio"). */
import type { JSX } from "react";
import { useAppState } from "../shell/store";
import { ViewFrame } from "../shell/ViewFrame";
import { Loading } from "../shell/Loading";
import { LoadError } from "../shell/LoadError";
import { currentSection } from "../shell/sections";

export function SectionHome({
  noun,
  loadWhat,
}: {
  noun: string;
  loadWhat: string;
}): JSX.Element {
  const { state, store } = useAppState();
  if (state.loadError) return <LoadError what={loadWhat} />;
  /* D15 — the empty-list copy invites creating the first record; showing it
     mid-fetch invites a duplicate of one that is about to appear */
  if (state.loadPending) return <Loading what={loadWhat} />;
  const section = currentSection(store);
  return (
    <ViewFrame
      banner={
        <div className="banner">
          <b>{section?.label}.</b>
          <span>No record open.</span>
        </div>
      }
    >
      {state.listError ? (
        <p className="form-error" role="alert" tabIndex={-1}>
          {state.listError}
        </p>
      ) : null}
      <div className="area-note">
        <p>
          <b>File → View…</b> opens a {noun} from its folder; <b>File → New draft…</b> starts one.
        </p>
        <p>
          Draft, review, active, and archived are the record's <b>status</b>, shown on it — not
          places it lives.
        </p>
      </div>
    </ViewFrame>
  );
}
